import { palette } from "@leafygreen-ui/palette";
import { createGlyphComponent } from "@via-ds/icons";

const { red } = palette;

export const KnownFailure = createGlyphComponent(
  "KnownFailure",
  "0 0 16 16",
  <path
    d="M11.5354 3.75727L11.5354 3.75728L12.2425 4.46439L12.2426 4.46442C12.4379 4.65969 12.4378 4.97621 12.2426 5.17146L12.2425 5.1715L9.76772 7.64638L9.41418 7.99993L9.76772 8.35348L12.2425 10.8284L12.2426 10.8284C12.4378 11.0237 12.4378 11.3402 12.2426 11.5354L12.2425 11.5355L11.5354 12.2426C11.3402 12.4378 11.0236 12.4378 10.8283 12.2426L8.35348 9.76769L7.99993 9.41413L7.64637 9.76769L5.17152 12.2426C4.97625 12.4378 4.65966 12.4378 4.46439 12.2426C4.46439 12.2426 4.46438 12.2426 4.46438 12.2426L3.75729 11.5355L3.75728 11.5355C3.56203 11.3402 3.56203 11.0236 3.75728 10.8284L3.75729 10.8284L6.23216 8.35348L6.58571 7.99993L6.23216 7.64638L3.75729 5.1715L3.75729 5.17149C3.56203 4.97624 3.56202 4.65966 3.75729 4.46439L3.75729 4.46439L4.46439 3.75729C4.46439 3.75729 4.46439 3.75728 4.46439 3.75728C4.65966 3.56202 4.97624 3.56203 5.17151 3.75729L7.64637 6.23216L7.99993 6.58572L8.35348 6.23216L10.8283 3.75728L10.8283 3.75727C11.0236 3.56203 11.3402 3.56203 11.5354 3.75727Z"
    fill="none"
    stroke="currentColor"
  />,
  { defaultFill: red.base, label: "Known Failure Icon" },
);
